export default __webpack_public_path__ + "static/trustpilot-e8eff521c5aad13421c0e1fee8a93a06.svg";